import PropTypes from 'prop-types';
import React from 'react';

const ClearAllFiltersControl = ({clearFilter}) => {
    return (
        <a className="clear-all-tags" onClick={e => clearFilter()}>
            Clear Filters
        </a>
    );
};

ClearAllFiltersControl.propTypes = {
    clearFilter: PropTypes.func.isRequired
};

export default ClearAllFiltersControl;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/posts_controls_row/clear_all_filters_control.js